@if (isTriggered()) {
    
    <!-- start fallback -->
    @let fallback = getTemplate('fallbackTemplate');
    @if (fallback; as tmpl) {
        <ng-container *ngTemplateOutlet="tmpl.templateRef; context: { $implicit: isTriggered() }" />
    } @else {
        <span appBadge="secondary" appearance="label">{{ fallbackKey() | translate }}</span>
    }
    
} @else {

    <!-- start value -->
    @let valueT = getTemplate('valueTemplate');
    @if (valueT; as tmpl) {
        <ng-container *ngTemplateOutlet="tmpl.templateRef; context: { $implicit: value() }" />
    } @else {
        {{ value() }}
    }
    
}
